module.exports = __webpack_public_path__ + "static/media/image-upload.2160818f.png";